export default "__VITE_ASSET__4U2O9UaN__"